import { Alert, Link, Modal, ModalBody, ModalHeader, Text, VFlow } from 'bold-ui'
import React, { useState } from 'react'
import { SOLICITACAO_EXAMES_PROCEDIMENTOS_TAB_NAME } from 'view/atendimentos/detail/soap/plano/components/PlanoTabs'

export function RelatorioGerencialExamesInfoAlert() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => setIsModalOpen(true)
  const handleCloseModal = () => setIsModalOpen(false)

  return (
    <>
      <Alert inline type='info'>
        O relatório gerencial de exames apresenta a contagem dos exames solicitados e avaliados em atendimentos
        individuais e odontológicos. A origem dos exames deste relatório são o CDS e o PEC.{' '}
        <Link onClick={handleOpenModal}>Saiba mais</Link>
      </Alert>
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <ModalHeader title='Detalhamento de dados do relatório' />
        <ModalBody>
          <VFlow>
            <VFlow vSpacing={0}>
              <Text>
                São considerados{' '}
                <Text component='span' fontWeight='bold'>
                  exames solicitados
                </Text>
              </Text>
              <Text component='li'>
                Exames assinalados com "S" referente a "Exames Solicitado(s)" no Atendimento individual do CDS.
              </Text>
              <Text component='li'>
                Exames registrados na aba de "{SOLICITACAO_EXAMES_PROCEDIMENTOS_TAB_NAME}" no Plano do Atendimento
                individual ou odontológico no SOAP.
              </Text>
            </VFlow>
            <VFlow vSpacing={0}>
              <Text>
                São considerados{' '}
                <Text component='span' fontWeight='bold'>
                  exames avaliados
                </Text>
              </Text>
              <Text component='li'>
                Exames assinalados com "A" referente a "Exames Avaliado(s)" no Atendimento individual do CDS.
              </Text>
              <Text component='li'>
                Exames registrados através do botão "Adicionar resultados de exames" no Objetivo do Atendimento
                individual ou odontológico no SOAP.
              </Text>
              <Text component='li'>
                Procedimentos que pertencem ao grupo SIGTAP 02 - Procedimentos com finalidade diagnóstica inclusos pelo
                atendimento odontológico do CDS ou pelo odontograma do atendimento odontológico do PEC.
              </Text>
            </VFlow>
            <VFlow vSpacing={0}>
              <Text fontWeight='bold'>Retrocompatibilidade dos dados do relatório</Text>
              <Text>
                Exames com resultados estruturados, procedimentos do grupo SIGTAP 02 - Procedimentos com finalidade
                diagnóstica do atendimento odontológico do CDS e do odontograma do Atendimento odontológico do PEC são
                exibidos independente da versão.
              </Text>
            </VFlow>
            {/* TODO (eldorado #25329) atualizar versão se necessário */}
            <Alert inline type='info'>
              As solicitações e avaliações de exames referentes a atendimentos odontológicos do PEC, importações de
              outras instalações do PEC e importações de sistemas terceiros só estão disponíveis para atendimentos
              registrados a partir da versão{' '}
              <Text component='span' fontWeight='bold' color='info'>
                5.4.2
              </Text>
              .
            </Alert>
          </VFlow>
        </ModalBody>
      </Modal>
    </>
  )
}
